import React from "react";
import { Route, Routes } from "react-router-dom";
import FormFolder from "./FormFolder/FormFolder";
import ListFolder from "./ListFolder/ListFolder";

const Folder = () => {
  return (
    <div className="folder">
      <Routes>
        <Route path="/" exact element={<ListFolder />} />
        <Route path="/*" exact element={<div>Erreur</div>} />
      </Routes>
    </div>
  );
};

export default Folder;
